<div class="promo-stacks-top-bar {{ user? 'top-bar-user-logged-in' : 'top-bar-user-logged-out' }}">
  <div class="header">
    <div>&nbsp;</div>
    <h4 class="title">A New Way to Book Promos</h4>
    <div>
      <button (click)="open = !open"><img src="{{ open? '../../../../../assets/img/promo-stacks-top-bar/up-arrow-icon.svg' : '../../../../../assets/img/promo-stacks-top-bar/down-arrow-icon.svg' }}" class="close" alt=""></button>
    </div>
  </div>
  @if (open) {
    <div>
      <div class="content">
        <img src="../../../assets/img/promo-stacks-modal/promo-stacks-logo.svg" class="promo-stacks-logo" alt="">
        <p class="description">Schedule an entire promo stack at once! Choose from our ready-made stacks to boost your book sales, save time, and make the Amazon algorithm work for you. Click below to view available promo stacks!</p>
      </div>
      <div class="footer">
        <button class="button regular solid-white" (click)="promosStacks()">Get Started</button>
      </div>
    </div>
  }
</div>
